import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
//errors: string[]
const ApiErrors = ({ errors }) => {
	const iconChoice = 'Error';
	return (
		<>
			{errors.length > 0 ? (
				<Alert severity={iconChoice.toLowerCase()}>
					<AlertTitle>{iconChoice}</AlertTitle>
					<ul>
						{errors?.map((error, index) => {
							return <li key={index}>{error}</li>;
						})}
					</ul>
					<p>
						You may review current values and attempt to resubmit
						this form.{' '}
					</p>
				</Alert>
			) : null}
		</>
	);
};

export default ApiErrors;
